
<div>
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item v-for="(item, index) in crumbList" :key="item">
      <span @click="handleLink(index)" :style="{cursor:(crumbList.length === 3 && index === 1) ? 'pointer' : 'auto'}">
        {{
          index === crumbList.length - 1 && !isNeedIn
            ? item
            : $t(`menu.${item}`)
        }}
      </span>
    </el-breadcrumb-item>
  </el-breadcrumb>
</div>
